/* Gamers Point unpublished navigation enhancement, no analytics and no external requests */
(() => {
  "use strict";
  if (window.__gpMegaV2Active) return;
  window.__gpMegaV2Active = true;
  const roots = new WeakSet();
  const dictionary = {
    headset: ["headphone", "audio", "سماعات"], mouse: ["mice", "ماوس", "فأرة"],
    keyboard: ["keyboards", "كيبورد", "لوحة مفاتيح"], wifi: ["wi-fi", "network", "واي فاي"],
    cable: ["connector", "adapter", "سلك", "كابل"], bluetooth: ["بلوتوث"],
    rgb: ["lighting", "lights", "إضاءة"], webcam: ["camera", "كاميرا"],
    nvme: ["ssd", "storage", "اس اس دي"], gpu: ["graphics", "كرت شاشة"]
  };
  function norm(str) {
    return (str || "").toLocaleLowerCase().normalize("NFKD").replace(/[\u064B-\u065F]/g, "").replace(/[-‐‑]/g, " ").replace(/\s+/g," ").trim();
  }
  const termHits = (text, q) => {
    const base=norm(text), key=norm(q);
    if (!key || base.includes(key)) return true;
    return Object.entries(dictionary).some(([name, variants]) =>
      (norm(name)===key || variants.some(v=>norm(v)===key)) &&
      (base.includes(norm(name)) || variants.some(v=>base.includes(norm(v))))
    );
  };
  function init(root) {
    if (roots.has(root)) return;
    roots.add(root);
    const side = root.querySelector(".gp-mega-departments");
    const departments=[...root.querySelectorAll("[data-gp-department]")];
    const panels=[...root.querySelectorAll("[data-gp-panel]")];
    const promos=[...root.querySelectorAll("[data-gp-promo]")];
    const search=root.querySelector("[data-gp-search]");
    const noResults=root.querySelector("[data-gp-no-results]");
    const last=root.querySelector("[data-gp-recent]");
    const extraLinks=[...root.querySelectorAll("[data-gp-extra]")];
    const groups=[...root.querySelectorAll("[data-gp-group]")];
    const filterPanels=[...root.querySelectorAll("[data-gp-facet]")];
    let hoverTimer=null;
    let active=root.dataset.gpDefaultDepartment || "Accessories";
    function activate(name) {
      if (!panels.some(p=>p.dataset.gpPanel===name)) return;
      active=name;
      departments.forEach(a=>{
        const selected=a.dataset.gpDepartment===name;
        a.classList.toggle("gp-mega-dept-link--active",selected);
        if (selected) a.setAttribute("aria-current","true");
        else a.removeAttribute("aria-current");
      });
      panels.forEach(p=>p.hidden=p.dataset.gpPanel!==name);
      promos.forEach(p=>p.hidden=p.dataset.gpPromo!==name);
      if (search){search.value="";search.setAttribute("aria-label", "Find categories in "+name);}
      groups.forEach(g=>g.hidden=false);
      root.querySelectorAll("[data-gp-extra]").forEach(el=>el.hidden=true);
      root.querySelectorAll("[data-gp-more]").forEach(b=>{b.hidden=false;b.setAttribute("aria-expanded","false");});
      noResults.hidden=true;
      root.querySelectorAll("[data-gp-only-accessories]").forEach(el=>el.hidden=name!=="Accessories");
      try {
        if (name !== "Accessories") sessionStorage.setItem("gp_last_browsed_department",name);
        if (last && name !== "Accessories") {
          last.textContent="Recently explored: "+name;
          last.hidden=false;
        }
      } catch(e) {}
    }
    departments.forEach(a=>{
      a.addEventListener("pointerenter", event => {
        if (event.pointerType==="touch")return;
        clearTimeout(hoverTimer);
        hoverTimer=setTimeout(()=>activate(a.dataset.gpDepartment),175);
      });
      a.addEventListener("pointerleave",()=>clearTimeout(hoverTimer));
      a.addEventListener("focus",()=>activate(a.dataset.gpDepartment));
      a.addEventListener("keydown", e=>{
        if(!["ArrowDown","ArrowUp"].includes(e.key))return;
        e.preventDefault();
        const index=departments.indexOf(a);
        departments[(index+(e.key==="ArrowDown"?1:-1)+departments.length)%departments.length].focus();
      });
    });
    side.addEventListener("pointerleave",()=>clearTimeout(hoverTimer));
    root.querySelectorAll("[data-gp-more]").forEach(button=>{
      button.addEventListener("click",()=>{
        const container=button.closest("[data-gp-group]");
        const expanding=button.getAttribute("aria-expanded")!=="true";
        container.querySelectorAll("[data-gp-extra]").forEach(el=>el.hidden=!expanding);
        button.setAttribute("aria-expanded",String(expanding));
        button.textContent=expanding?"Show fewer":"More categories";
      });
    });
    if(search){
      search.addEventListener("input",()=>{
        const q=search.value.trim();
        let found=0;
        root.querySelectorAll("[data-gp-panel]").forEach(p=>{
          if(p.hidden)return;
          p.querySelectorAll("[data-gp-group]").forEach(g=>{
            const links=[...g.querySelectorAll(".gp-mega-links li")];
            const heading=g.querySelector("h3")?.textContent||"";
            let groupFound=0;
            links.forEach(li=>{
              const ok=termHits(li.textContent,q) || termHits(heading,q);
              li.hidden=!ok;
              if(ok)groupFound++;
            });
            const has=q?groupFound>0:true;
            g.hidden=!has;
            found+=has?groupFound:0;
            const more=g.querySelector("[data-gp-more]");
            if(more)more.hidden=Boolean(q);
          });
        });
        if(noResults){
          noResults.hidden=!q||found>0;
          const a=noResults.querySelector("a");
          if(a)a.href="/search?type=product&q="+encodeURIComponent(q);
        }
      });
    }
    root.querySelectorAll("[data-gp-facet-tab]").forEach(btn=>{
      btn.addEventListener("click",()=>{
        const name=btn.dataset.gpFacetTab;
        root.querySelectorAll("[data-gp-facet-tab]").forEach(x=>{
          x.setAttribute("aria-selected",String(x===btn));
          x.classList.toggle("is-active",x===btn);
        });
        filterPanels.forEach(p=>p.hidden=p.dataset.gpFacet!==name);
      });
    });
    root.addEventListener("keydown",e=>{
      if(e.key==="Escape"){
        const trigger=root.closest(".menu-list__submenu")?.previousElementSibling?.querySelector(".menu-list__disclosure");
        if(trigger?.getAttribute("aria-expanded")==="true"){e.preventDefault();trigger.click();trigger.focus();}
      }
    });
    root.querySelectorAll("[data-gp-more]").forEach(btn=>{
      const parent=btn.closest("[data-gp-group]");
      btn.hidden=!parent?.querySelector("[data-gp-extra]");
    });
    try {
      const previous=sessionStorage.getItem("gp_last_browsed_department");
      if(previous && last && departments.some(d=>d.dataset.gpDepartment===previous)){last.textContent="Previously browsed: "+previous;last.hidden=false;}
    }catch(e){}
    activate(root.dataset.gpDefaultDepartment || "Accessories");
  }
  const setup=()=>document.querySelectorAll('[data-gp-mega="accessories"]').forEach(init);
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",setup,{once:true});
  else setup();
  document.addEventListener("shopify:section:load",setup);
})();